<template>
  <div class="user" v-if="user">
    <el-container>
      <el-header height="100px" class="with-tags">
        <el-button class="header-btn pull-right"
                   type="primary"
                   icon="el-icon-circle-plus"
                   @click="createTask"
                   v-if="isAdmin || currentUser.id === user.id"> Create New Task</el-button>
        <client-code v-if="!user.icon" :code="user.first_name.substr(0, 1).toUpperCase() + user.last_name.substr(0, 1).toUpperCase()" :seed="user.first_name" />
        <img v-if="user.icon" :src="user.icon_url" class="client-code"/>
        <h2 @click="editUser" class="card-title">{{ user.first_name }} {{ user.last_name }} <i v-if="isAdmin || currentUser.id === user.id" class="el-icon-edit-outline"></i></h2>
        <div class="tags">
          <el-tag size="small"><icon name="keyboard" /> {{ user.position }}</el-tag>
          <el-tag type="danger" size="small"><icon name="envelope" /> {{ user.email }}</el-tag>
          <el-tag type="warning" size="small"><icon name="lightbulb" /> {{ userCreatedDateString }}</el-tag>
          <el-tag size="small" :type="(user.status == 1) ? 'success' : 'info'">{{ (user.status == 1) ? 'Active' : 'Inactive' }}</el-tag>
        </div>
      </el-header>
      <el-main class="panels">
        <task-list title="Tasks"
                   :show-status-tag="true"
                   :show-client-code="true"
                   :tasks="userTasks"
                   :user="user"
                   v-if="user" />
      </el-main>
    </el-container>

    <user-crud :user="user"
               v-if="showUserCrud"
               @close="userCrudClose" />

    <task-crud v-if="showTaskCrud"
               :userId="user.id"
               @close="taskCrudClose" />
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'user',
    components: {},
    data () {
      return {
        user: null,
        showUserCrud: false,
        showTaskCrud: false
      }
    },
    methods: {
      editUser () {
        if (this.isAdmin || this.currentUser.id === this.user.id) {
          this.showUserCrud = true
        }
      },
      createTask () {
        this.showTaskCrud = true
      },
      userCrudClose (user) {
        // Handle the User Crud Dialog closing
        this.showUserCrud = false
        if (user) {
          this.user = this.users[user.id]
        }
      },
      taskCrudClose (task) {
        // Handle the Project Crud Dialog closing
        this.showTaskCrud = false

        if (task) {
          this.$router.push({name: 'task', params: { task_id: task.id }})
        }
      },
      handleRouteParamUserId () {
        this.user = this.users[this.routeParamUserId]

        this.$store.dispatch('getUser', this.routeParamUserId)
        this.$store.dispatch('getTasks', {user_id: this.routeParamUserId})
      },
      setPageTitle () {
        if (this.user) {
          this.$store.dispatch('setPageTitle', 'Users')
        }
      }
    },
    computed: {
      // Vuex Mappings
      currentUser () {
        return this.$store.state.users.currentUser
      },
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      users () {
        return this.$store.state.users.objects
      },

      // Methods
      userTasks () {
        // Return all logs related to the current user, that happened today
        var tasks = []
        if (this.user) {
          tasks = Object.keys(this.tasks).map((k) => this.tasks[k]).filter(function (item) {
            // Only return tasks belonging to the current user, that aren't complete (1) or cancelled (6)
            if (item.group_task) {
              return item.group_users.indexOf(this.user.id) !== -1 && item.status !== 1 && item.status !== 6
            } else {
              return (item.user_id === this.user.id && item.status !== 1 && item.status !== 6)
            }
          }.bind(this))
        }
        return tasks
      },

      tasks () {
        return this.$store.state.tasks.objects
      },

      // Vue Router Params
      routeParamUserId () {
        if (this.$route.name === 'account') {
          return this.currentUser.id
        } else {
          return this.$route.params.user_id
        }
      },
      userCreatedDateString () {
        if (this.user.created_at == null) {
          return 'Created (unknown)'
        } else {
          return 'Created ' + moment.utc(this.user.created_at).local().format('D/M/YY')
        }
      }
    },
    created () {
      this.handleRouteParamUserId()
    },
    mounted () {
      this.$store.dispatch('setPageTitle', 'User Details')
      this.handleRouteParamUserId()
    },
    watch: {
      // When the route is programatically changed (e.g. when a different user is selected)
      // the route 'user_id' param (this.userId) will change.
      // Re-init the Component's data when this happens
      'user' () {
        this.setPageTitle()
        // If the user is valid show them, otherwise go back
        // This case would happen if the user had just been deleted
        // by the UserCRUD, in which case this component will update and
        // unmount the UserCRUD and show a blank page.
        // Instead we go back()
        if (!this.user) {
          // User was deleted, go back to user list
          window.history.back()
        } else {
          this.handleRouteParamUserId()
        }
      },
      // During Component creation, and after a new User is added, the Vuex users list
      // will change. Watch for this change and update the Component's data when it happens
      'users' () {
        this.handleRouteParamUserId()
      },
      'currentUser' () {
        this.handleRouteParamUserId()
      },
      // If a user manually changes the route, force update the Component's data
      '$route' () {
        this.handleRouteParamUserId()
      }
    }
  }
</script>
<style lang="less" scoped>
  .card-title {
    cursor: pointer;
  }
</style>
